import { isEqual, difference, isArray, isNull } from 'lodash-es'

export const judgeOpts = ({ opts, values, defaultValues }) => {
  const _opts = { ...opts }
  const { logicSpec } = opts
  const { conditions, logicType, results = {} } = logicSpec

  const _conditions = values.map((v, i) => {
    const condition = conditions[i]

    if (condition.op === 'equal' && !condition.refSlug) {
      return isEqual(condition.value, v)
    }
    if (condition.op === 'equal' && condition.refSlug) {
      _opts[condition.refSlug] = v
    }
    if (condition.op === 'inList') {
      return (condition.value || []).includes(v)
    }
    if (condition.op === 'notInList') {
      return !(condition.value || []).includes(v)
    }
    if (condition.op === 'containArray' && v) {
      return (
        difference(
          v,
          isArray(condition.value) ? condition.value : [condition.value]
        ).length < v.length
      )
    }
    if (condition.op === 'notContainArray' && v) {
      return (
        difference(
          v,
          isArray(condition.value) ? condition.value : [condition.value]
        ).length === v.length
      )
    }
    if (condition.op === 'notNull') {
      if (v) {
        return true
      }
    }
    if (condition.op === 'isNull') {
      if (!v) {
        return true
      }
    }
    if (condition.op === 'notModified') {
      if (
        !isNull(defaultValues[condition.slug]) &&
        defaultValues[condition.slug] === v
      ) {
        return true
      }
    }
    if (condition.op === 'isModified') {
      if (defaultValues[condition.slug] !== v) {
        return true
      }
    }

    // (数值、时间类型独有)待优化
    if (condition.op === 'gt' || condition.op === 'gte') {
      _opts.min = v
      _opts.minDate = v
    }

    if (condition.op === 'lt' || condition.op === 'lte') {
      _opts.max = v
      _opts.maxDate = v
    }

    return false
  })

  let obj = false

  if (logicType === 'or') {
    obj = _conditions.reduce((l, r) => {
      return l || r
    }, false)
  }

  if (logicType === 'and') {
    obj = _conditions.reduce((l, r) => {
      return l && r
    }, true)
  }

  if (obj) {
    return { ..._opts, ...results.opts }
  }

  return _opts
}
